import { captureException, withScope } from '@sentry/browser';

import { isAxiosResponseError } from './api';

export interface LogErrorContext {
  contextKey: string;
  contextPayload: Record<string, string>;
}

export const logError = (err: unknown, context?: LogErrorContext) => {
  if (!process.env.REACT_APP_SENTRY_DSN) {
    // eslint-disable-next-line no-console
    console.error(err);

    return;
  }

  const isAuthError =
    isAxiosResponseError(err) &&
    (err.response.status === 401 ||
      err.response.status === 403 ||
      err.response.status === 419 ||
      err.response.status === 422);

  if (isAuthError) {
    return;
  }

  if (context) {
    withScope((scope) => {
      scope.setContext(context.contextKey, context.contextPayload);
      captureException(err);
    });
  } else {
    captureException(err);
  }
};
